/*
  This is a modified version of https://github.com/Scrivito/scroll-to-fragment
  Main change was to replace "touchend" stop event with "touchstart".
  Touchend seemed to cause scroll stuttering if touch scrolling started within the observe timeout.
*/

/*
MIT License

Copyright (c) 2020 David Császár

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

export function scrollToFragment () {
  unmount()
  mount()
}

function mount () {
  documentObserver = new MutationObserver(handleDomMutation) // eslint-disable-line
  document.addEventListener('click', handleDocumentClick)
  startObserving()
}

function unmount () {
  stopObserving()
  document.removeEventListener('click', handleDocumentClick)
  documentObserver = undefined
}

function startObserving () {
  stopObserving()
  if (!getLocation().hash) return

  STOP_EVENTS.forEach(addStopListener)
  documentObserver?.observe(document, OBSERVER_CONFIG)
  adjustScrollPosition()

  observeTimeout = setTimeout(stopObserving, OBSERVE_TIMEOUT_MS)
}

function stopObserving () {
  clearTimeout(observeTimeout)
  window.cancelAnimationFrame(throttleRequestId)
  documentObserver?.disconnect()
  STOP_EVENTS.forEach(removeStopListener)
}

function addStopListener (eventName) {
  document.addEventListener(eventName, stopObserving)
}

function removeStopListener (eventName) {
  document.removeEventListener(eventName, stopObserving)
}

function handleDocumentClick (event) {
  if (event.defaultPrevented) return

  const anchor = closestAIncludingSelf(event.target)
  if (!anchor || !anchor.hash) return
  if (anchor.pathname === getLocation().pathname) throttle(startObserving)
}

function closestAIncludingSelf (element) {
  let target = element
  while (target && target.nodeName !== 'A') target = target.parentElement
  return target
}

function handleDomMutation () {
  throttle(adjustScrollPosition)
}

function adjustScrollPosition () {
  const hash = getLocation().hash
  if (!hash) return

  const fragmentId = decodeURIComponent(hash.substring(1))
  const element = document.getElementById(fragmentId)
  if (element) element.scrollIntoView()
}

function getLocation () {
  return window.location
}

function throttle (callback) {
  window.cancelAnimationFrame(throttleRequestId)
  throttleRequestId = window.requestAnimationFrame(callback)
}

let documentObserver
let observeTimeout
let throttleRequestId

const OBSERVER_CONFIG = {
  attributes: true,
  characterData: true,
  childList: true,
  subtree: true
}

const OBSERVE_TIMEOUT_MS = 10000
const STOP_EVENTS = ['touchstart', 'selectstart', 'wheel']
